import { createReducer } from '@reduxjs/toolkit'

const initialState = {
  items: [],
  currentItem: {},
  pagination: {
    total: 1,
    page: 1,
    pageCount: 1
  },
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: ''
}

const queues = createReducer(initialState, {
  'queues/GET_PICKUP': (state, action) => ({
    ...state,
    isFetching: true
  }),
  'queues/GET_PICKUP_SUCESSFULL': (state, action) => {
    return {
      ...state,
      items: action.payload.response.data,
      isFetching: false,
      pagination: {
        total: action.payload.response.meta.total_count,
        pageCount: action.payload.response.meta.page_count,
        page: action.payload.current_page
      }
    }
  },
  'queues/GET_PICKUP_FAILURE': (state, action) => {
    return {
      ...state,
      isFetching: false,
      isError: true,
      errorMessage: action.payload
    }
  },
  'queues/DELETE': (state, action) => {
    return {
      ...state,
      isFetching: true
    }
  },
  'queues/DELETE_SUCCESSFUL': (state, action) => {
    return {
      ...state,
      items: state.items.filter(
        item => String(item.id) !== String(action.payload)
      ),
      isFetching: false
    }
  },
  'queues/DELETE_FAILURE': (state, action) => {
    return {
      ...state,
      isFetching: false,
      isError: true,
      errorMessage: action.payload
    }
  },
  'queues/GET_BY_ID': (state, action) => {
    return {
      ...state,
      isFetching: true
    }
  },
  'queues/GET_BY_ID_SUCCESSFUL': (state, action) => {
    return {
      ...state,
      isFetching: false,
      currentItem: action.payload
    }
  },
  'queues/GET_BY_ID_FAILURE': (state, action) => {
    return {
      ...state,
      isFetching: false,
      currentItem: {},
      errorMessage: action.payload
    }
  },
  'queues/CLEAR_CURRENT': (state, action) => {
    return {
      ...state,
      currentItem: {}
    }
  },
  'queues/CLEAR_PICKUP_QUEUES': (state, action) => {
    return {
      ...initialState
    }
  }
})

export default queues
